import {
  ButtonLink,
  FormInputInlineEdit,
  Grid,
  Paragraph,
  VerticalSpacing,
} from '@we-agile-you/react-base';
import React, { useState } from 'react';
import { DISPLAY_NAME_MAX_LENGTH, updateCurrentUser } from '@we-agile-you/auth';
import { useAuthActions } from '../../../spaces/auth/hooks/useAuthActions';
import useCurrentUser from '../../../spaces/auth/hooks/useCurrentUser';

import { DeleteAccountModal } from '../../DeleteAccountModal/DeleteAccountModal';

export const MyAccount = () => {
  const { isAnonymous, isPremium, user, email } = useCurrentUser();
  const [isDeleteAccountModalOpen, setIsDeleteAccountModalOpen] =
    useState(false);
  const { updateEmail, updatePassword } = useAuthActions();

  const handleDeleteAccount = () => {
    setIsDeleteAccountModalOpen(true);
  };

  const handleEditDisplayName = ([displayName]: string[]) =>
    updateCurrentUser({ displayName });

  const handleEditEmail = ([newEmail, password]: string[]) =>
    updateEmail(password, newEmail);

  const handleChangePassword = ([newPassword, password]: string[]) =>
    updatePassword(password, newPassword);

  if (!isDeleteAccountModalOpen && isAnonymous) {
    return null;
  }

  const renderPage = () => {
    if (!user || isPremium === null || isAnonymous) {
      return null;
    }

    return (
      <Grid container spacing={3} justify="center">
        <Grid item xs={12}>
          <FormInputInlineEdit
            label="Display name"
            value={user.displayName || ''}
            inputs={[
              {
                id: 'display-name',
                maxLength: DISPLAY_NAME_MAX_LENGTH,
                value: user.displayName || '',
                required: true,
              },
            ]}
            onConfirm={handleEditDisplayName}
          />
          <VerticalSpacing spacing="spacing-l" />
          {email && (
            <FormInputInlineEdit
              label="Email"
              value={email}
              inputs={[
                {
                  id: 'new-email',
                  type: 'email',
                  label: 'New email',
                  value: '',
                  required: true,
                },
                {
                  id: 'email-password',
                  type: 'password',
                  label: 'Please type your password',
                  value: '',
                  required: true,
                },
              ]}
              onConfirm={handleEditEmail}
            />
          )}
          <VerticalSpacing spacing="spacing-l" />
          <FormInputInlineEdit
            label="Password"
            value="********"
            inputs={[
              {
                id: 'new-password',
                type: 'password',
                label: 'New password',
                value: '',
                required: true,
              },
              {
                id: 'password-password',
                type: 'password',
                label: 'Current password',
                value: '',
                required: true,
              },
            ]}
            onConfirm={handleChangePassword}
          />
          <VerticalSpacing spacing="spacing-xl" />
          <Paragraph>
            <ButtonLink onClick={handleDeleteAccount} buttonColor="danger">
              Delete account
            </ButtonLink>
          </Paragraph>
          <VerticalSpacing spacing="spacing-xs" />
          <Paragraph color="grey500">
            Delete your user and all his data.
          </Paragraph>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {renderPage()}
      {isDeleteAccountModalOpen && (
        <DeleteAccountModal
          onClose={() => setIsDeleteAccountModalOpen(false)}
        />
      )}
    </>
  );
};
